import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TagState, Tag, Link, LinksModalState, LinkLookup, GridFilter } from "./types";
import { Task } from "common/types";

const initialState: TagState = {
    showGridSpinner: false,
    modalHeader: "Edit tag",
    selectedIds: [],
    gridSource: {
        data: [],
        total: 0,
        filter: {
            searchString: '',
            pageNumber: 1,
            pageSize: 50,
            taskIds: [],
        },
    },
    linksModal: {
        open: false,
        locked: false,
        lookup: [],
        tag: null,
        searchString: '',
        source: {
            data: [],
            total: 0,
            filter: {
                linkAction: 0,
                pageNumber: 1,
                pageSize: 20,
                searchString: '',
                tagId: 0,
                taskId: 0
            }
        },
    },
    linkModal: {
        open: false,
        locked: false,
    },
    link: {
        lookup: {
            scenarioIds: [],
            value: [],
        },
        errors: {
            value: [],
            scenarioIds: [],
            tagId: [],
        },
        links: {
            scenarioIds: [],
            tagId: 0,
            value: '',
        },
    },
    task: null,
    tagEditModal: {
        open: false,
        locked: false,
        source: null
    }
};

export const tagsSlice = createSlice({
    name: "tags",
    initialState,
    reducers: {
        setGridSource(state, action: PayloadAction<{ data: Tag[]; total: number; filter: GridFilter }>) {
            state.gridSource.data = action.payload.data;
            state.gridSource.total = action.payload.total;
            state.gridSource.filter = action.payload.filter;
        },
        changeFilter(state, action: PayloadAction<Partial<GridFilter>>) {
            state.gridSource.filter = { ...state.gridSource.filter, ...action.payload };
        },
        toggleGridSpinner(state, action: PayloadAction<boolean>) {
            state.showGridSpinner = action.payload;
        },
        setModalHeader(state, action: PayloadAction<string>) {
            state.modalHeader = action.payload;
        },
        changeSelected(state, action: PayloadAction<number[]>) {
            state.selectedIds = action.payload;
        },
        setTask(state, action: PayloadAction<Task>) {
            state.task = action.payload;
        },
        // Links Modal
        toggleLinksModalOpen(state, action: PayloadAction<boolean>) {
            state.linksModal.open = action.payload;
        },
        setLinksLookup(state, action: PayloadAction<string[]>) {
            state.linksModal.lookup = action.payload;
        },
        toggleLinksModalLocked(state, action: PayloadAction<boolean>) {
            state.linksModal.locked = action.payload;
        },
        setLinksModalGridSource(state, action: PayloadAction<{ data: Link[]; total: number; filter: Partial<LinksModalState['source']['filter']> }>) {
            state.linksModal.source.data = action.payload.data;
            state.linksModal.source.total = action.payload.total;
            state.linksModal.source.filter = { ...state.linksModal.source.filter, ...action.payload.filter };
        },
        setLinksModalTag(state, action: PayloadAction<Tag>) {
            state.linksModal.tag = action.payload;
        },
        changeLinksModalFilter(state, action: PayloadAction<string>) {
            state.linksModal.searchString = action.payload;
        },
        // Link Edit Modal
        toggleLinkEditModalOpen(state, action: PayloadAction<boolean>) {
            state.linkModal.open = action.payload;
        },
        toggleLinkEditModalLocked(state, action: PayloadAction<boolean>) {
            state.linkModal.locked = action.payload;
        },
        editLink(state, action: PayloadAction<Partial<{ scenarioIds: number[]; tagId: number; value: string; }>>) {
            state.link.links = { ...state.link.links, ...action.payload };
        },
        setLinkLookup(state, action: PayloadAction<LinkLookup>) {
            state.link.lookup = action.payload;
        },
        setLinkErrors(state, action: PayloadAction<Partial<typeof state.link.errors>>) {
            state.link.errors = {
                ...state.link.errors,
                ...action.payload,
            };
        },
        resetLink(state) {
            state.link = initialState.link;
        },
        resetLinkModal(state) {
            state.linkModal = initialState.linkModal;
        },
        openTagEditModal(state, action: PayloadAction<Partial<Tag>>) {
            state.tagEditModal.open = true;
            state.tagEditModal.source = action.payload;
        },
        closeTagEditModal(state) {
            state.tagEditModal = initialState.tagEditModal;
        },
        editFieldTagModal(state, action) {
            state.tagEditModal.source = {
                ...state.tagEditModal.source,
                ...action.payload
            };
        },
        toggleTagModalSpinner(state, action: PayloadAction<boolean>) {
            state.tagEditModal.locked = action.payload;
        },
    },
});

export const actions = tagsSlice.actions;
export default tagsSlice.reducer;
